import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=3df68f4d&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=3df68f4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df68f4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3df68f4d')) {
      api.createRecord('3df68f4d', component.options)
    } else {
      api.reload('3df68f4d', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=3df68f4d&scoped=true&", function () {
      api.rerender('3df68f4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KfTSb0b8WfxP/JS/comp/PopupBox.vue"
export default component.exports